module.exports = __webpack_public_path__ + "static/media/gear_disabled.36b9eae8.svg";